<template>
  <div :class="[$style.container, settings && settings.reversed ? $style.reversed : '' ]">
    <div :class="[$style.text]">
      <TextBlock
        :reversed="settings && settings.reversed ? settings.reversed : false"
        :content="content.text"
        :title="content.title" />
    </div>
    <ul :class="$style.iconsList">
      <li>
        <BigIcon :class="$style.image" :src="content.images[0]" :index="0" />
      </li>
      <li>
        <img v-lazy="content.images[1]">
        <!-- <FigureBlock :class="$style.image" :src="content.images[1]" /> -->
      </li>
    </ul>
  </div>
</template>

<script>
import TextBlock from '@/components/TextBlock'
import BigIcon from '@/components/BigIcon'
import FigureBlock from '@/components/FigureBlock'

export default {
  props: ['content', 'settings'],

  components: {
    TextBlock,
    BigIcon,
    FigureBlock
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.text {
  width: 100%;
  flex: 0 1 auto;

  @include mq(sm) {
    width: 40%;
  }

  @include mq(md) {
    width: 30%;
  }
}

.container {
  @include grid-size();
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: $big-margin-mobile;

  @include mq(sm) {
    flex-flow: row;
    justify-content: space-between;
    padding: $big-margin;

    &.reversed {
      flex-flow: row-reverse;
    }
  }

}

.iconsList {
  display: flex;
  width: 100%;
  flex: 0 0 100%;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;

  @include mq(sm) {
    width: 50%;
    flex: 0 0 50%;
    margin-top: 0;
  }

  @include mq(md) {
    width: 60%;
    flex: 0 0 60%;
  }

  li {
    padding: $small-margin-mobile * 2;

    @include mq(sm) {
      padding: $small-margin-mobile;
      margin-right: $big-margin;
    }

    img {
      max-width: 100%;

      @include mq($from: sm, $until: md) {
        max-width: 140px;
      }
    }
  }

  .image {
  margin: 0 auto;
  width: 90px;
  padding: 0;

    @include mq(sm) {
      width: 90px;
      height: 90px;
    }

    @include mq(ds) {
      width: 130px;
      height: 130px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoBlockHalf.vue